/**
 * The server holds every portal call behind acceptance of the current terms and says so with this
 * code. The client that sees it cannot reach React, so it raises a window event and the terms gate,
 * which can, reloads the terms and puts the dialog up.
 */
export const TERMS_ACCEPTANCE_REQUIRED = "TERMS_ACCEPTANCE_REQUIRED";
export const TERMS_REQUIRED_EVENT = "partner:terms-acceptance-required";

export const isTermsRequiredError = (error) =>
  error?.response?.status === 403 && error?.response?.data?.errorCode === TERMS_ACCEPTANCE_REQUIRED;

export const announceTermsRequired = () => {
  window.dispatchEvent(new Event(TERMS_REQUIRED_EVENT));
};
